var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item-container",class:{
    'active-item': _vm.active,
    'done-item': _vm.done,
    'first-item': _vm.first,
    'last-item': _vm.last,
  }},[_c('div',{staticClass:"bullet"},[(_vm.done)?_c('v-icon',{staticStyle:{"position":"absolute"},attrs:{"color":"text","size":36}},[_vm._v(" mdi-check ")]):_vm._e(),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }